import {ReactComponent as IconInfoSuccess} from '../../../../../assets/images/icon-info-success.svg';
import useURI from "../../../../../hooks/useURI";
import useAuth from "../../../../../hooks/useAuth";
import {useCurrentWorkspaceDetailQuery} from "../../../../../hooks/queries";
import {useEffect, useRef} from "react";
import {Trans, useTranslation} from "react-i18next";
import AivatarButtonV2 from "../../../../../components/buttons/AivatarButtonV2";

function ProModalContent({openDashboard}) {
  const {uri} = useURI();
  const {data: workspace} = useCurrentWorkspaceDetailQuery();
  const {user} = useAuth();
  const videoRef = useRef(null);
  const {t, i18n} = useTranslation('self-custom-modal')

  const isKorean = i18n.language.startsWith('ko');
  const videoSrc = isKorean
    ? '/videos/self-custom-modal.mp4'
    : '/videos/self-custom-modal_en.mp4';

  const onCLickFileUpload = () => {
    window.open(
      `${uri['self-avatar-upload']}?email_address=${user.email}&workspace_number=${workspace?.id}`,
    );
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
      videoRef.current.muted = true;
    }
  }, []);

  return (
    <div className="flex flex-row w-full h-full">
      <div className="w-[350px] h-[622px] p-4 flex flex-col justify-center items-center gap-4">
        <div className="w-full h-full bg-[#EDEDED] rounded-lg flex justify-center items-center">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            ref={videoRef}
            className="w-full h-full object-cover rounded-lg"
            controls loop
            controlsList="nofullscreen"
          >
            <source src={videoSrc} type="video/mp4"/>
            {isKorean
              ? '브라우저가 동영상을 지원하지 않습니다.'
              : 'Your browser does not support the video.'
            }
          </video>
        </div>
      </div>

      <div className="w-[487px] h-[622px] px-10 py-11 flex flex-col justify-center gap-3.5">
        <div className="text-headline02 text-black">
          <Trans t={t}>
            셀프 커스텀 아바타,<br/>
            지금 바로 제작해 보세요.
          </Trans>
        </div>
        <div className="text-body01 text-base text-black">
          <Trans t={t}>
            내 스타일, 내 제스처, 내 목소리 그대로!<br/>
            <span className="font-bold">직접 촬영하고 녹음</span>하여 나만의 아바타를 만들어 보세요.
          </Trans>
        </div>

        <div className="flex flex-col gap-1.5 mt-[20px]">
          <div className="flex items-start gap-3.5">
            <IconInfoSuccess size={24} className="shrink-0 mt-[2px]"/>
            <div className="flex flex-col justify-center text-body01 text-base leading-[24px]">
              {t('웹캠이나 스마트폰으로 촬영하면 5분 안에 생성돼요.')}
            </div>
          </div>
          <div className="flex items-start gap-3.5">
            <IconInfoSuccess size={24} className="shrink-0 mt-[2px]"/>
            <div className="flex flex-col justify-center text-body01 text-base leading-[24px]">
              {t('내 목소리 그대로 글로벌 언어로 소통하세요.')}
            </div>
          </div>
          <div className="flex items-start gap-3.5">
            <IconInfoSuccess size={24} className="shrink-0 mt-[2px]"/>
            <div className="flex flex-col justify-center text-body01 text-base leading-[24px]">
              {t('의상도 배경도 내 스타일대로! 자유롭게 설정하세요.')}
            </div>
          </div>

          <div className="flex flex-col gap-2 mt-2 w-full">
            <div className="flex items-center text-body01 text-[#001F54] font-medium">
              <a href={uri['aivatar-contact-us']} target="_blank" rel="noreferrer"
                 className="flex items-center gap-1">
                <span>{t('문의하기↗')}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3.5 bg-[#F5F7F9] px-3.5 py-5 rounded-[9.73px] mt-[18px]">
          <div className="text-center text-body01 text-sm font-medium text-[#001F54]">
            <Trans t={t}>
              🎉 플랜 구독 후 영상을 업로드하면 아바타가 즉시 생성됩니다.<br/>
              궁금한 점이 있으면 언제든 문의해 주세요.
            </Trans>
          </div>
          <div className="w-96 flex justify-center items-center gap-10">
            <AivatarButtonV2
              type="button"
              onClick={() => window.open(uri['self-avatar-guide'], '_blank', 'noopener,noreferrer')}
              className="px-5 py-2 h-[40px] bg-slate-400 hover:bg-gs01-300 text-body01 text-white text-sm font-medium rounded-xl inline-flex justify-center items-center gap-1.5 text-center"
            >
              {t('상세 가이드 보기')}
            </AivatarButtonV2>
            <AivatarButtonV2
              type="button"
              className="px-5 py-[6px] h-[40px] bg-main-1 hover:bg-[#004FFF] text-body01 text-white text-sm font-medium rounded-xl inline-flex justify-center items-center gap-1.5 text-center"
              onClick={openDashboard}
            >
              {t('지금 시작하기')}
            </AivatarButtonV2>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProModalContent;
